import { render, staticRenderFns } from "./ReportIssueUpdate.vue?vue&type=template&id=df381392&scoped=true&"
import script from "./ReportIssueUpdate.vue?vue&type=script&lang=js&"
export * from "./ReportIssueUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df381392",
  null
  
)

export default component.exports